module.exports = __webpack_public_path__ + "img/86ca5aa.jpg";